import Vec2 from 'vec2';

import { getMidpoint } from '~/core/helpers';
import { DrawingEdge } from '~/core/models';

export const buildBumpOutArrayOfPoints = (
  edge: DrawingEdge,
  bumpOutLength: number,
  bumpOutDepth: number
) => {
  // build array of points for bump out
  const bumpVec: Vec2[] = [];

  if (edge.bumpOut?.clockwiseRemainderLength) {
    bumpVec.push(
      edge.startDisplayVec.add(
        edge.dirVec
          .normalize(true)
          .multiply(edge.bumpOut?.clockwiseRemainderLength, true),
        true
      )
    );
  } else {
    const midPoint = getMidpoint(edge.startDisplayVec, edge.endDisplayVec);

    bumpVec.push(
      midPoint.subtract(
        edge.dirVec.normalize(true).multiply(bumpOutLength / 2, true),
        true
      )
    );
  }
  bumpVec.push(
    bumpVec[0].add(edge.normalVec.multiply(bumpOutDepth, true), true)
  );
  bumpVec.push(
    bumpVec[1].add(
      edge.dirVec.normalize(true).multiply(bumpOutLength, true),
      true
    )
  );
  bumpVec.push(
    bumpVec[2].subtract(edge.normalVec.multiply(bumpOutDepth, true), true)
  );

  return bumpVec;
};
